import { render, staticRenderFns } from "./GSelectFormStaff.vue?vue&type=template&id=44d46f9c&scoped=true&"
import script from "./GSelectFormStaff.vue?vue&type=script&lang=ts&"
export * from "./GSelectFormStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d46f9c",
  null
  
)

export default component.exports